// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc97c820","453":"a317ad31","732":"c3401e56"}[chunkId] + ".chunk.js";
};